export default __webpack_public_path__ + "static/media/Animations_Cog1.996eee52.svg";